<template>
    <div class="scanner">
        <loading v-if="loading"/>
        <section class="">
            <div class="container">
                <div class="row">
                    <p v-if="debug">{{ browser }}</p>
                    <!-- ios 顯示以下 -->
                    <div class="col-lg-12 tips-iphone" v-if="safari">
                        <ul>

                          <li>請點選右上角<img src="img/parkit/tips_ios_share.png" alt="" />圖示。</li>
                          <li>再點選<span>【使用 Sarfari 瀏覽】</span>開啟網頁。</li>
                          <li><span>【允許】</span>取用相機，即可掃描 QR Code。</li>

                        </ul>
                    </div>
                    <!-- ios 顯示以上 -->

                    <!-- android 顯示以下 -->
                    <div class="col-lg-12 tips-android" v-if="android">
                        <ul>

                          <li>請點選右上角<img src="img/parkit/tips_ios_share.png" alt="" />圖示。</li>
                          <li>再點選<span>【使用 Chrome 瀏覽】</span>開啟網頁。</li>
                          <li><span>【允許】</span>取用相機，即可掃描 QR Code。</li>

                        </ul>
                    </div>
                    <!-- android 顯示以上 -->

                    <div class="col-lg-12 text-center scanner-box" v-if="!safari && !android && !showScanResult">
                        <span>請您將 QR Code 對準畫面即可掃描</span>
                    </div>
                </div>
                <qrcode-stream class="qrcode" v-if="!safari && !android && !showScanResult" @decode="onDecode" @init="onInit">
                    <transition name="fade">
                        <div style="text-align: center; margin-top: 12px; text-shadow: 2px 2px #434a54;" class="text-warning" v-if="scan_hint">
                            {{ scan_hint }}
                        </div>
                    </transition>
    
                    <div class="qr-top-left"></div>
                    <div class="qr-top-right"></div>
                    <div class="qr-bottom-left"></div>
                    <div class="qr-bottom-right"></div>
                </qrcode-stream>

            </div>
        </section>

        <div class="plate-modal modal fade" id="invoice-success-modal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="close-modal" data-dismiss="modal" v-on:click="keepScan()">
                    <div class="lr">
                    <div class="rl"></div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                    <div class="col-lg-8 mx-auto">
                        <div class="modal-body">
                        <!-- Project Details Go Here -->
                        <h3 class="">發票登錄成功</h3>
                        <p class="item-intro text-muted">
                            發票號碼： {{ invoice_number }} <br>
                            {{ discount_description }}
                        </p>
                        <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button">
                            折抵紀錄
                        </button>
                        <button class="btn btn-primary btn-green" data-dismiss="modal" type="button" v-on:click="keepScan()">
                            繼續掃描
                        </button>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- modal-content ends -->
            </div><!-- modal-dialog ends -->
        </div>

      <div class="plate-modal modal fade" id="invoice-error-modal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="close-modal" data-dismiss="modal" v-on:click="keepScan()">
              <div class="lr">
                <div class="rl"></div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8 mx-auto">
                  <div class="modal-body">
                    <!-- Project Details Go Here -->
                    <h3 class="text-danger">發票登錄失敗</h3>
                    <p class="item-intro text-muted">
                        發票號碼： {{ invoice_number }} <br>
                        不符合折抵規則
                    </p>
                    <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button">
                        折抵紀錄
                    </button>
                    <button class="btn btn-primary btn-green" data-dismiss="modal" type="button" v-on:click="keepScan()">
                        繼續掃描
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- modal-content ends -->
        </div><!-- modal-dialog ends -->
      </div>
      <!-- plate-delete-modal ends -->

    </div>
</template>

<script>

import { QrcodeStream} from 'vue-qrcode-reader'

export default {
  name: 'ScannerView',
  components: {
    QrcodeStream,
  },
  props: {
  },
  data() {
    return {
      loading: true,
      error: "",
      browser: "",
      safari: false,
      android: false,
      debug: false,
      showScanResult: false,
      recording: false,
      discount_description: "",
      invoice_number: "",
      scan_hint: ""
    }
  },
  mounted() {
    var self = this
    self.browser = navigator.userAgent
  },
  methods: {
    onDecode (decodedString) {
        var self = this
        if (decodedString.length >= 77 && ! self.recording) {
            self.recording = true
            const invoice_number = decodedString.substring(0, 10)
            const invoice_date = decodedString.substring(10, 17)
            const invoice_random = decodedString.substring(17, 21)
            const invoice_sell_price = parseInt(decodedString.substring(21, 29), 16).toString(10)
            const invoice_total_sell_price = parseInt(decodedString.substring(29, 37), 16).toString(10)
            const invoice_buy_tax_number = decodedString.substring(37, 45)
            const invoice_sell_tax_number = decodedString.substring(45, 53)
            const invoice_aes_encode = decodedString.substring(53, 77)

            const new_invoice_date = String(parseInt(invoice_date.substring(0,3)) + 1911) + invoice_date.substring(3, 7) + "000101"

            self.invoice_number = invoice_number

            if (/^[A-Z]{2}[0-9]{8}$/.test(invoice_number)) {
                self.scan_hint = ""
                self.showScanResult = true
                self.loading = true
                self.$http.post('https://'+ process.env.VUE_APP_API_URL +'/discount?token=cmtB2GJTr4VOq3raei2y', {
                    "license_plate": self.$route.query.plate,
                    "device_id": "IKEA-CUSTOMER-PHONE",
                    "receipts": [
                        {
                            "receipt_number": invoice_number, 
                            "seller_tax_code": invoice_sell_tax_number, 
                            "consumption_time": new_invoice_date, 
                            "amount": invoice_total_sell_price,
                            "random": invoice_random,
                        }
                    ]
                })
                .then((response) => {
                    self.loading = false
                    if (response.body.results[0].status === 1) {
                        self.discount_description = response.body.results[0].description
                        $("#invoice-success-modal").modal("show")
                    } else {
                        $("#invoice-error-modal").modal("show")
                    }
                })
                .catch((response) => {
                })
                .finally(() => {
                    self.recording = false
                });
            }
        } else {
            self.scan_hint = "請掃描左邊 QR Code"
        }
    },
    async onInit (promise) {
        var self = this

        try {
            await promise
        } catch (error) {
            self.checkBrowser()
            if (error.name === 'NotAllowedError') {
                // user denied camera access permisson
            } else if (error.name === 'NotFoundError') {
                // no suitable camera device installed
            } else if (error.name === 'NotSupportedError') {
                // page is not served over HTTPS (or localhost)
            } else if (error.name === 'NotReadableError') {
                // maybe camera is already in use
            } else if (error.name === 'OverconstrainedError') {
                // passed constraints don't match any camera.
                // Did you requested the front camera although there is none?
            } else if (error.name === 'StreamApiNotSupportedError') {
                // browser seems to be lacking features
            }
        } finally {
            self.loading = false
        }
    },
    checkBrowser() {
        var self = this
         if(navigator.userAgent.indexOf("iPhone") >= 0){
            self.android = false
            self.safari = true
        }
        if (navigator.userAgent.indexOf("Android") >= 0) {
            self.android = true
            self.safari = false
        }
    },
    keepScan() {
        var self = this

        $("#invoice-error-modal").modal("hide")
        $("#invoice-success-modal").modal("hide")
        self.showScanResult = false
    }
  }
}
</script>